// eslint-disable-next-line import/prefer-default-export
export const CAUSES = {
	WRONG_PORTAL: 'WRONG_PORTAL',
	NO_ACCOUNT_LOGIN: 'NO_ACCOUNT_LOGIN',
};

export const MANAGE_REDIRECT_CAUSES = [CAUSES.WRONG_PORTAL];
